module.exports = __webpack_public_path__ + "img/blog-1.d663b33e.jpg";